// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"51468a93","228":"51468a93","233":"51468a93","685":"51468a93","877":"51468a93"}[chunkId] + ".chunk.css";
};